module.exports = "/dashboard/manage/locations/locationsGroupComponent-787403.html";